import React from "react";

const SponsorshipBenefits = () => {
  const benefits = [
    {
      benefit: "Brand Visibility",
      exhibition: "Basic",
      coSponsor: "Standard",
      associate: "Premium",
      title: "Exclusive",
    },
    {
      benefit: "Logo on Marketing Materials",
      exhibition: "✗",
      coSponsor: "✓",
      associate: "✓",
      title: "✓",
    },
    {
      benefit: "Speaking Opportunity",
      exhibition: "✗",
      coSponsor: "✗",
      associate: "15 min",
      title: "30 min Keynote",
    },
    {
      benefit: "Media Coverage",
      exhibition: "✗",
      coSponsor: "Basic",
      associate: "Standard",
      title: "Premium",
    },
    {
      benefit: "VIP Networking Events",
      exhibition: "✗",
      coSponsor: "✗",
      associate: "✓",
      title: "Private Events",
    },
  ];

  return (
    <section className="section-padding" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <h2
              style={{
                fontSize: "36px",
                fontWeight: "bold",
                marginBottom: "40px",
                textAlign: "center",
                color: "#333",
              }}
            >
              Sponsorship Benefits
            </h2>

            {/* Table Container */}
            <div
              style={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                padding: "20px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                overflowX: "auto",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  minWidth: "800px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#f8f9fa",
                      borderBottom: "2px solid #dee2e6",
                    }}
                  >
                    <th
                      style={{
                        padding: "15px",
                        textAlign: "left",
                        fontWeight: "bold",
                        fontSize: "16px",
                        color: "#333",
                      }}
                    >
                      BENEFIT
                    </th>
                    <th
                      style={{
                        padding: "15px",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "16px",
                        color: "#333",
                      }}
                    >
                      EXHIBITION STALL
                    </th>
                    <th
                      style={{
                        padding: "15px",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "16px",
                        color: "#333",
                      }}
                    >
                      CO-SPONSOR
                    </th>
                    <th
                      style={{
                        padding: "15px",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "16px",
                        color: "#333",
                      }}
                    >
                      ASSOCIATE SPONSOR
                    </th>
                    <th
                      style={{
                        padding: "15px",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "16px",
                        color: "#007BFF",
                      }}
                    >
                      TITLE SPONSOR
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {benefits.map((row, index) => (
                    <tr
                      key={index}
                      style={{
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      <td
                        style={{
                          padding: "15px",
                          fontWeight: "600",
                          color: "#333",
                        }}
                      >
                        {row.benefit}
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          textAlign: "center",
                          color: row.exhibition === "✗" ? "#dc3545" : "#666",
                          fontWeight: row.exhibition === "✗" ? "normal" : "500",
                          fontSize: row.exhibition === "✗" ? "18px" : "14px",
                        }}
                      >
                        {row.exhibition}
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          textAlign: "center",
                          color: row.coSponsor === "✗" ? "#dc3545" : "#666",
                          fontWeight: row.coSponsor === "✗" ? "normal" : "500",
                          fontSize: row.coSponsor === "✗" ? "18px" : "14px",
                        }}
                      >
                        {row.coSponsor}
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          textAlign: "center",
                          color: row.associate === "✗" ? "#dc3545" : "#666",
                          fontWeight: row.associate === "✗" ? "normal" : "500",
                          fontSize: row.associate === "✗" ? "18px" : "14px",
                        }}
                      >
                        {row.associate}
                      </td>
                      <td
                        style={{
                          padding: "15px",
                          textAlign: "center",
                          color: row.title === "✗" ? "#dc3545" : "#666",
                          fontWeight: row.title === "✗" ? "normal" : "500",
                          fontSize: row.title === "✗" ? "18px" : "14px",
                        }}
                      >
                        {row.title}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Call to Action */}
            <div
              style={{
                marginTop: "40px",
                textAlign: "center",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  color: "#666",
                  marginBottom: "20px",
                }}
              >
                Looking for a custom sponsorship package? Contact our team to
                create a tailored solution for your brand.
              </p>
              <a
                href="https://www.jsaonline.in/become-sponsorship"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#007BFF",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  padding: "15px 40px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  textDecoration: "none",
                  display: "inline-block",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "#0056b3";
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 5px 15px rgba(0,123,255,0.3)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "#007BFF";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "none";
                }}
              >
                Contact Sponsorship Team
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SponsorshipBenefits;
